<mat-form-field fxFlex.gt-md="60" fxFlex [formGroup]="group" appearance="outline" fxFlex.gt-sm>
  <mat-label>{{field.frontendLabel}}</mat-label>

  <input [attr.guide]="'date-inp-1' + '__' + sanitizeUrl(url)" [required]="group.controls[field.attributeCode].status == 'INVALID' ? true : false" [autocomplete]="'off'"
    disabled [formControlName]="field.attributeCode" matInput [matDatepicker]="picker"/>
  <mat-datepicker-toggle matSuffix [for]="picker">
  </mat-datepicker-toggle>
  <mat-datepicker disabled="false" #picker></mat-datepicker>

  <mat-error *ngIf="group.controls[field.attributeCode].status == 'INVALID'">
    Please fill out this field.</mat-error>
</mat-form-field>